import React, {Component, Fragment} from 'react'
import {observer} from 'mobx-react'

import WaProgressBar from 'lib/struct/WaProgressBar'
import Status from 'lib/control/Status'
import Error from 'lib/struct/Error'
import SpanButton, {Colors} from 'lib/control/SpanButton'

import Field from '../struct/Field'

import styles from './SaveAndExport.less'
import SettingsGroup from "../struct/SettingsGroup";
import Cookies from "js-cookie";

const LOADING_IMG = 'img/loading32.gif'

@observer export default class ProfileSaveAndExportComponent extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const v2 = Cookies.get('force_set_wa_backend_ui_version') == 2

        return (
            <div className={(v2 ? "fields " : '') + styles['block']}>
                <SettingsGroup>
                    <Field wide>
                        <TempBlock context={context}/>

                        <div className={styles['save-button-hint']}>
                            Изменения в настройках сохранятся во время экспорта и будут автоматически применены к
                            последующим сессиям экспорта с использованием этого профиля.
                        </div>
                    </Field>
                </SettingsGroup>
            </div>
        )
    }
}

@observer
class TempBlock extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        const button_is_disabled = context.xml_generator || context.saving_status !== Status.NONE

        if (context.xml_generator) {
            if (!context.xml_generator.isCompleted()) {
                return (
                    <WaProgressBar
                        progress={context.xml_generator.completion_percent}
                        className={styles['progress-bar']}
                        loading_image={context.getUrl(LOADING_IMG)}
                        description={context.xml_generator.getDescription()}
                    />
                )
            }

            return (
                <Fragment>
                    <ButtonsBlock context={context}/>

                    <div className={styles['generation-description']}>
                        {
                            context.xml_generator.is_failed ? (
                                <Error error={context.xml_generator.error_message}/>
                            ) : (
                                <div>{context.xml_generator.current_state_description}</div>
                            )
                        }
                    </div>
                </Fragment>
            )
        }

        if (!button_is_disabled) {
            return (
                <ButtonsBlock context={context}/>
            )
        }

        return (
            <Status status={context.saving_status}/>
        )
    }
}

@observer
class ButtonsBlock extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context

        const button_is_disabled = context.xml_generator || context.saving_status !== Status.NONE

        return (
            <Fragment>
                <SpanButton
                    onClick={() => context.runXmlGeneration()}
                    color={Colors.GREEN}
                    disabled={button_is_disabled}
                >
                    Сохранить и запустить генерацию YML
                </SpanButton>

                <SpanButton
                    onClick={() => context.saveProfile()}
                    color={Colors.YELLOW}
                    disabled={button_is_disabled}
                    className={styles['save-button']}
                >
                    Сохранить
                </SpanButton>
            </Fragment>
        )
    }
}